'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import PageError from '~/components/flp/PageError';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';

type OwnProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: OwnProps) {
  const router = useRouter();
  const trackEvent = useTrackEvent();

  const [isLoading, setIsLoading] = useState(false);

  const tryReset = async () => {
    datadogRum.addAction(DATADOG_EVENTS.PAGE_ERROR.CLICKED_PAGE_RESET);
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 700));
      reset();
    } finally {
      setIsLoading(false);
    }
  };

  const handleHomeNavigation = () => {
    datadogRum.addAction(DATADOG_EVENTS.PAGE_ERROR.CLICKED_GO_HOME);
    router.push('/');
  };

  useEffect(() => {
    datadogRum.addError(DATADOG_EVENTS.PAGE_ERROR.ERROR_PAGE_VIEWED, { error });
    trackEvent('oopsPageError', {
      digest: error?.digest,
      error: error?.message,
      page: 'financing'
    });
  }, [error, trackEvent]);

  return (
    <PageError
      isLoading={isLoading}
      onGoHome={handleHomeNavigation}
      onTryAgain={tryReset}
    />
  );
}
